import { Directive, Injectable, OnDestroy, TemplateRef, inject, signal } from '@angular/core';

/**
 * Slots de la topbar (design-preview `.topbar`) : chaque page projette ses
 * chips de filtres (`.filters`, après le titre) et ses stat-chips/actions
 * (`.stats`, alignés à droite) via les directives structurelles ci-dessous —
 * le shell les rend avec NgTemplateOutlet.
 */
@Injectable({ providedIn: 'root' })
export class TopbarSlots {
  readonly filters = signal<TemplateRef<unknown> | null>(null);
  readonly stats = signal<TemplateRef<unknown> | null>(null);
  /** Remplace le titre de route (pages détail : « ← Nom + chips »). */
  readonly title = signal<TemplateRef<unknown> | null>(null);
}

@Directive({ selector: 'ng-template[appTopbarTitle]' })
export class TopbarTitleTpl implements OnDestroy {
  private readonly slots = inject(TopbarSlots);
  private readonly template = inject(TemplateRef<unknown>);

  constructor() {
    this.slots.title.set(this.template);
  }

  ngOnDestroy(): void {
    if (this.slots.title() === this.template) {
      this.slots.title.set(null);
    }
  }
}

@Directive({ selector: 'ng-template[appTopbarFilters]' })
export class TopbarFiltersTpl implements OnDestroy {
  private readonly slots = inject(TopbarSlots);
  private readonly template = inject(TemplateRef<unknown>);

  constructor() {
    this.slots.filters.set(this.template);
  }

  ngOnDestroy(): void {
    if (this.slots.filters() === this.template) {
      this.slots.filters.set(null);
    }
  }
}

@Directive({ selector: 'ng-template[appTopbarStats]' })
export class TopbarStatsTpl implements OnDestroy {
  private readonly slots = inject(TopbarSlots);
  private readonly template = inject(TemplateRef<unknown>);

  constructor() {
    this.slots.stats.set(this.template);
  }

  ngOnDestroy(): void {
    if (this.slots.stats() === this.template) {
      this.slots.stats.set(null);
    }
  }
}
